import {
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
  Tooltip,
} from 'antd';
import {InfoCircleOutlined} from '@ant-design/icons';
import styles from '../../subscriptionSettings.module.scss';
import CatalogModalSection from './CatalogModalSection';

const CatalogPurchaseSettingsSection = ({
  purchaseType,
  purchaseTypes,
  durationUnits,
}) => {
  return (
    <CatalogModalSection
      title="Purchase setup"
      description="Pick purchase behavior, duration, and visibility settings.">
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Purchase type"
            name="purchaseType"
            rules={[{required: true, message: 'Purchase type required'}]}>
            <Select options={purchaseTypes} />
          </Form.Item>
        </Col>
        {purchaseType === 'TIME_BASED' ? (
          <>
            <Col span={6}>
              <Form.Item
                label="Duration unit"
                name="durationUnit"
                rules={[{required: true, message: 'Duration unit required'}]}>
                <Select options={durationUnits} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label="Duration value"
                name="durationValue"
                rules={[
                  {required: true, message: 'Duration value required'},
                  {type: 'number', min: 1, message: 'Minimum is 1'},
                ]}>
                <InputNumber
                  className="input-number"
                  min={1}
                  style={{width: '100%'}}
                />
              </Form.Item>
            </Col>
          </>
        ) : null}
        {purchaseType === 'ONE_OFF' ? (
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  Redirect URL&nbsp;
                  <Tooltip title="Optional link to open after a user completes this one-off subscription purchase.">
                    <InfoCircleOutlined style={{color: '#8b82a7'}} />
                  </Tooltip>
                </span>
              }
              name="redirectUrl"
              rules={[{type: 'url', message: 'Enter a valid URL'}]}>
              <Input placeholder="https://example.com/next-step" />
            </Form.Item>
          </Col>
        ) : null}
      </Row>

      <div className={styles['catalog-switch-grid']}>
        <Form.Item
          label={
            <span>
              Allow coupon&nbsp;
              <Tooltip title="Allow users to apply promo codes during checkout.">
                <InfoCircleOutlined style={{color: '#8b82a7'}} />
              </Tooltip>
            </span>
          }
          name="allowCoupon"
          valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Allow recurring&nbsp;
              <Tooltip title="if this is checked, the user will be to turn on/off auto-renewal at checkout.">
                <InfoCircleOutlined style={{color: '#8b82a7'}} />
              </Tooltip>
            </span>
          }
          name="allowRecurring"
          valuePropName="checked"
          hidden={purchaseType === 'ONE_OFF'}>
          <Switch disabled={purchaseType === 'ONE_OFF'} />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Default recurring&nbsp;
              <Tooltip title="If allow recurring is checked, this will be selected by default at checkout.">
                <InfoCircleOutlined style={{color: '#8b82a7'}} />
              </Tooltip>
            </span>
          }
          name="defaultRecurring"
          valuePropName="checked"
          hidden={purchaseType === 'ONE_OFF'}>
          <Switch disabled={purchaseType === 'ONE_OFF'} />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Visible to users&nbsp;
              <Tooltip title="If disabled, users cannot see or purchase this item in the app.">
                <InfoCircleOutlined style={{color: '#8b82a7'}} />
              </Tooltip>
            </span>
          }
          name="isVisibleToUsers"
          valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Enabled&nbsp;
              <Tooltip title="If disabled, this item cannot be processed entirely.">
                <InfoCircleOutlined style={{color: '#8b82a7'}} />
              </Tooltip>
            </span>
          }
          name="isEnabled"
          valuePropName="checked">
          <Switch />
        </Form.Item>
      </div>
    </CatalogModalSection>
  );
};

export default CatalogPurchaseSettingsSection;
